import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

const DEFAULT_BRAND_PRIMARY = '#5B1CFF';
const DEFAULT_BRAND_SECONDARY = '#8A66FF';

export const setBrandColors = ({
  primary = DEFAULT_BRAND_PRIMARY,
  secondary = DEFAULT_BRAND_SECONDARY,
} = {}) => {
  document.documentElement.style.setProperty('--color-brand-primary', primary);
  document.documentElement.style.setProperty(
    '--color-brand-secondary',
    secondary
  );
};

export const setColorTheme = isOSOnDarkMode => {
  const selectedColorScheme =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'dark';
  if (
    (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
    selectedColorScheme === 'dark'
  ) {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }
};
